import { Record } from 'immutable';

type TypeFormationSanitaire = {
    id: string,
    nom: string,
    districtId: string,
}

const FormationSanitaireRecord = Record({
    id: '',
    nom: '',
    districtId: '',
});

class FormationSanitaire extends FormationSanitaireRecord {

    get id(): string {
        return this.get('id')
    }

    get nom(): string {
        return this.get('nom')
    }

    get districtId(): string {
        return this.get('districtId')
    }

    constructor(props: Partial<TypeFormationSanitaire> = {}) {
        super(({
            ...props,
        }));
    }

    setId(id: string): this {
        return this.set('id', id)
    }

    setNom(nom: string): this {
        return this.set('nom', nom)
    }

    setDistrictId(districtId: string): this {
        return this.set('districtId', districtId)
    }
}

export default FormationSanitaire;